(function () {
  var DAY = 86400000;
  var HOUR = 3600000;
  var MINUTE = 60000;
  var SECOND = 1000;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function expire(el) {
    var container = el.closest('[data-urgency-container]');
    (container || el).setAttribute('hidden', '');
  }

  function init(el) {
    if (el.dataset.countdownReady) return;
    el.dataset.countdownReady = 'true';

    var deadline = Date.parse(el.dataset.deadline);
    if (isNaN(deadline)) {
      el.remove();
      return;
    }

    var showDays = el.dataset.hideDays !== 'true';
    var daysPart = el.querySelector('[data-part="days"]');
    var fields = {
      days: el.querySelector('[data-unit="days"]'),
      hours: el.querySelector('[data-unit="hours"]'),
      minutes: el.querySelector('[data-unit="minutes"]'),
      seconds: el.querySelector('[data-unit="seconds"]')
    };

    var timer;

    function tick() {
      var remaining = deadline - Date.now();

      if (remaining <= 0) {
        clearInterval(timer);
        expire(el);
        return;
      }

      var days = Math.floor(remaining / DAY);
      var hours = Math.floor((remaining % DAY) / HOUR);
      var minutes = Math.floor((remaining % HOUR) / MINUTE);
      var seconds = Math.floor((remaining % MINUTE) / SECOND);

      if (showDays && days > 0) {
        daysPart.removeAttribute('hidden');
        fields.days.textContent = days;
      } else {
        daysPart.setAttribute('hidden', '');
        hours += days * 24;
      }

      fields.hours.textContent = pad(hours);
      fields.minutes.textContent = pad(minutes);
      fields.seconds.textContent = pad(seconds);

      el.classList.add('is-ready');
    }

    tick();
    timer = setInterval(tick, SECOND);
  }

  function scan() {
    document.querySelectorAll('[data-urgency-countdown]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scan();
  });
})();